export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o endereço <b>${this.currentEntity.name}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/index/resources/computed.js